// Copyright (c) 2019 Deere & Company

import actions from '../actions-list';

const pipNumber = (state, action) => action.pipNumber;

export default (state = '', action) => {

    const actionTypes = {
        [actions.UPDATE_OPEN_PIP_PROGRAMS_REPORT_PIP_NUMBER]: pipNumber
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/reducers/pip-number.js